import { render } from "./GitMenu.vue?vue&type=template&id=34f8e1ba&scoped=true"
import script from "./GitMenu.vue?vue&type=script&lang=js"
export * from "./GitMenu.vue?vue&type=script&lang=js"

import "./GitMenu.vue?vue&type=style&index=0&id=34f8e1ba&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f8e1ba"]])

export default __exports__